import 'moment/locale/id';
import * as ExcelJS from 'exceljs';
import 'moment-duration-format';
import { UserModel } from '../../app/modules/auth/models/UserModel';


interface Props {
    user: UserModel
    nameFile: string
    data: any[]
    weekNumbers?: number[] // Optional, used for dynamic week handling
}

export const exportExcelMeratus = async ({ user, nameFile, data, weekNumbers }: Props) => {
    const workbook = createWorkbook();
    const worksheet = createWorksheet(workbook, "Sheet 1");

    // Baris header
    worksheet.getRow(1).values = [
        'VISIT',
        ...(weekNumbers || []).flatMap((week) => [`Week ${week}`, '', '']),
        'Total', ''
    ];

    worksheet.getRow(2).values = [
        '', // visit
        ...(weekNumbers || []).flatMap((week) => [`Target`, 'Selesai', '']),
        'Q', '%'
    ];

    worksheet.getRow(3).values = [
        '', // visit
              ...(weekNumbers || []).flatMap((week) => [``, 'Q', '%']),
        '', ''
    ];

    const mergeCellsIfNotMerged = (worksheet: ExcelJS.Worksheet, startCell: string, endCell: string): void  => {
        const startColumn = worksheet.getCell(startCell);
        const endColumn = worksheet.getCell(endCell);
        
        // Check if the cells are already merged
        if (startColumn.isMerged || endColumn.isMerged) {
            return; // Skip merging if already merged
        }
        
        worksheet.mergeCells(startCell, endCell);
    };

    // Example usage in your case with dynamic merging
    let startColumnRow1 = 2;  // Starting column (B)
    let startColumnRow2 = 3;  // Starting column (B)
    let startColumnRow22 = 2;  // Starting column (B)

    weekNumbers?.forEach(() => {
        // Dynamically check if cells are already merged before merging
        mergeCellsIfNotMerged(worksheet, worksheet.getColumn(startColumnRow1).letter + '1', worksheet.getColumn(startColumnRow1 + 2).letter + '1');
        mergeCellsIfNotMerged(worksheet, worksheet.getColumn(startColumnRow2).letter + '2', worksheet.getColumn(startColumnRow2 + 1).letter + '2');
        mergeCellsIfNotMerged(worksheet, worksheet.getColumn(startColumnRow22).letter + '2', worksheet.getColumn(startColumnRow22).letter + '3');
        
        startColumnRow1 += 3; // Move to the next week's columns
        startColumnRow2 += 3; // Move to the next week's columns
        startColumnRow22 += 3; // Move to the next week's columns
    });



    addDataRows(worksheet, data, weekNumbers);
    setColumnWidths(worksheet);
    styleColumns(worksheet);

    // if (data.length > 0) worksheet.mergeCells('A4', 'A' + (3 + data.length));
    exportWorkbook(workbook, `${nameFile}.xlsx`);
};


const createWorkbook = () => {
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'Looyal';
    workbook.lastModifiedBy = 'Looyal';
    workbook.created = new Date();
    workbook.modified = new Date();
    return workbook;
};

const createWorksheet = (workbook: ExcelJS.Workbook, sheetName: string) => {
    let worksheet = workbook.addWorksheet(sheetName);
    return worksheet;
};

const addDataRows = (worksheet: ExcelJS.Worksheet, dataBranch: any[], weekNumbers: number[]|undefined) => {
    dataBranch.forEach((rowData) => {
        const row = [
            rowData.visit, // visit is static

            // Iterate over weekNumbers to add dynamic columns
            ...(weekNumbers || []).flatMap((week) => [
                rowData[`target_week_${week}`], // target for the week
                rowData[`quantity_week_${week}`], // quantity for the week
                rowData[`percentage_week_${week}`] // percentage for the week
            ]),

            // Add the total and percentage columns
            rowData.quantity_total,
            rowData.quantity_percentage,
        ];

        worksheet.addRow(row);
    });
};


const setColumnWidths = (worksheet: ExcelJS.Worksheet) => {
    worksheet.columns = [
        { width: 20 }, // visit
        { width: 12 }, { width: 10 }, { width: 10 },
        { width: 12 }, { width: 10 }, { width: 10 },
        { width: 12 }, { width: 10 }, { width: 10 },
        { width: 12 }, { width: 10 }, { width: 10 },
        { width: 12 }, { width: 10 }, { width: 10 },
        { width: 10 }, { width: 10 },
    ];
};


const styleColumns = (worksheet: ExcelJS.Worksheet) => {
    const allColumns = ['B','C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R'];
    allColumns.map((key) => {
        worksheet.getColumn(key).alignment = {
            vertical: 'middle',
            horizontal: 'right',
            wrapText: true,
        }
    });

    worksheet.getColumn('A').alignment = {
        vertical: 'middle',
        wrapText: true,
    }

    worksheet.getRow(1).alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
    };
    worksheet.getRow(2).alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
    };
    worksheet.getRow(3).alignment = {
        vertical: 'middle',
        horizontal: 'center',
        wrapText: true,
    };

    worksheet.getRow(1).font = {
        name: 'Arial Black',
        size: 10,
        bold: true,
    };
    worksheet.getRow(2).font = {
        name: 'Arial Black',
        size: 10,
        bold: true,
    };
    worksheet.getRow(3).font = {
        name: 'Arial Black',
        size: 10,
        bold: true,
    };
};

const exportWorkbook = async (workbook: ExcelJS.Workbook, fileName: string) => {
    workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
    });
};
